export const ZOHO_ACTION_URL = "https://desk.zoho.com/support/WebToCase";

export const ZOHO_TOKENS = {
  xnQsjsdp: "edbsn0874ec8db2534c1f4ac6dc22e20227d5",
  xmIwtLD: "edbsn725f6393da9096720e192da43e2fa033dfec7157846a2a9366ba3a2600fd3510",
};

export const ZOHO_ACTION_TYPE = "Q2FzZXM=";

export const ZOHO_FIELD_NAMES = {
  firstName: "First Name",
  lastName: "Contact Name",
  email: "Email",
  phone: "Phone",
  organization: "Organization",
  subject: "Subject",
  description: "Description",
};

export const DEFAULT_SUBJECT = "Contact form submission";

export const IFRAME_NAME = "zoho-iframe-target";

export const MIN_FILL_TIME_MS = 3000;

export const SUBMIT_TIMEOUT_MS = 15000;
